// orderService.js
import { mockOrders, mockProducts, mockCustomers } from '../data/salesData';

export const saveOrder = (order) => {
  const newOrder = {
    ...order,
    id: Date.now(),
    createdAt: new Date().toISOString(),
    status: 'pending',
  };
  mockOrders.push(newOrder);
  return newOrder;
};

export const sendToKitchen = (orderId) => {
  const order = mockOrders.find((o) => o.id === orderId);
  if (order) {
    order.status = 'in-progress';
    order.kitchenReceivedAt = new Date().toISOString();
    return true;
  }
  return false;
};

export const completeOrder = (orderId) => {
  const order = mockOrders.find((o) => o.id === orderId);
  if (order) {
    order.status = 'completed';
    order.completedAt = new Date().toISOString();
    return true;
  }
  return false;
};

export const getKitchenOrders = () => mockOrders.filter((order) => order.status !== 'completed');

export const getProductDetails = (productId) => mockProducts.find((p) => p.id === productId);

export const getCustomerDetails = (customerId) => mockCustomers.find((c) => c.id === customerId);

export const updateOrder = (orderId, updatedItems) => {
  const orderIndex = mockOrders.findIndex((o) => o.id === orderId);
  if (orderIndex !== -1) {
    const updatedOrder = {
      ...mockOrders[orderIndex],
      finalItems: updatedItems,
      total: updatedItems.reduce((sum, item) => sum + (item.price * item.quantity), 0),
      updatedAt: new Date().toISOString(),
    };
    mockOrders[orderIndex] = updatedOrder;
    return updatedOrder;
  }
  return null;
};
